import React from "react";

class CustomCheckBox extends React.Component {
  render() {
    return (
      <div
        style={{
          display: "flex",
          flex: 1,
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <input
          type="checkbox"
          id={this.props.property}
          onChange={e => this.props.onChange(e, this.props.property)}
          checked={this.props.checked}
          style={{ visibility: "hidden" }}
        />

        <label
          htmlFor={this.props.property}
          className="custom-checkbox"
          style={{
            height: "24px",
            width: "24px",
            border: "2px solid rgba(0,0,0,.5)",
            borderRadius: "3px",
            fontSize: "100%",
            fontWeight: "bolder",
            margin: "0 ",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <i
            className="material-icons"
            style={
              this.props.checked
                ? { visibility: "visible" }
                : { visibility: "hidden" }
            }
          >
            check
          </i>
        </label>
      </div>
    );
  }
}
export default CustomCheckBox;
